'use client';
/**
 * Позволяет расширять функциональность обработчиков событий на уровне
 * контейнерных компонентов, сохраняя поддержку отмены передачи управления
 * дополнительному обработчику, когда в обработчике верхнего уровня
 * вызывается event.preventDefault().
 * */ const composeHandlers = (main, extra, options)=>{
    const { checkForDefaultPrevented = true, pickEventFromArgs = (...args)=>args[0] } = options || {};
    return function handleEvent(...args) {
        const event = pickEventFromArgs(...args);
        main == null ? void 0 : main(...args);
        if (!checkForDefaultPrevented || !(event == null ? void 0 : event.defaultPrevented)) {
            return extra == null ? void 0 : extra(...args);
        }
    };
};

export { composeHandlers };
//# sourceMappingURL=composeHandlers.js.map
